module.exports = __webpack_public_path__ + "static/media/reward-points-golden-star.193e2b81.svg";